/**
 * Validates contact form data
 * @param {Object} formData - The form data to validate
 * @param {Object} options - Validation options
 * @param {boolean} options.validateCountry - Whether to validate country fields (default: true)
 * @returns {Object} Object containing validation errors
 */
export const validateContactForm = (formData, options = {}) => {
    const { validateCountry = true } = options;
    const newErrors = {};

    // Name validation
    if (!formData.name.trim()) {
        newErrors.name = "Name is required";
    }

    // Email validation
    if (!formData.email.trim()) {
        newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = "Invalid email";
    }

    // Phone validation
    if (!formData.phone.trim()) {
        newErrors.phone = "Phone is required";
    }

    // Country validation (optional)
    if (validateCountry) {
        if (!formData.country_name) {
            newErrors.country_name = "Country is required";
        }
        if (!formData.country_code) {
            newErrors.country_code = "Country code is required";
        }
    }

    // Comment validation
    if (!formData.comment.trim()) {
        newErrors.comment = "Please tell us about your project";
    }

    return newErrors;
};
